import React, { useState, useMemo } from "react";
import axios from "../api";
import { useHistory } from "react-router-dom";
import CierreTurnoFiltroForm from "./CierreTurnoFiltroForm";
import CierreTurnoTable from "./CierreTurnoTable";
import CierreDiaTable from "../CierreDia/CierreDiaTable";
import "./CierreTurno.css";

const ModificaRecaudoList = () => {
  const [cierreDiaData, setCierreDiaData] = useState([]);
  const [cierreTurnoData, setCierreTurnoData] = useState([]);

  const [filtros, setFiltros] = useState({
    codTerminal: "",
    codPark: "",
    fechaInicial: "",
  });
  const [accionSeleccionada, setAccionSeleccionada] = useState("consultar");
  const [buscando, setBuscando] = useState(false);
  const history = useHistory();

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const getInputConfig = (fieldName) => {
    const configs = {
      consultar: { codTerminal: true, codPark: true, fechaInicial: true },
      modificar: { codTerminal: true, codPark: false, fechaInicial: false },
      eliminar: { codTerminal: true, codPark: true, fechaInicial: true },
    };
    return !configs[accionSeleccionada][fieldName];
  };

  const handleAccionChange = (e) => {
    setAccionSeleccionada(e.target.value);
    handleLimpiar();
  };

  const buscarCierres = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    const { codTerminal, codPark, fechaInicial } = filtros;

    console.log('=== INICIO DE BÚSQUEDA ===');
    console.log('Tipo de búsqueda: CIERRE_TURNO (+ cierre día en misma acción)');
    console.log('Filtros completos:', filtros);
    console.log('Código Terminal:', codTerminal);
    console.log('Código Parqueadero:', codPark);
    console.log('Fecha Inicial:', fechaInicial);

    if (!codTerminal || !codPark || !fechaInicial) {
      alert("Por favor complete todos los campos de búsqueda (Código Terminal, Centro de Costos y Fecha)");
      return;
    }

    // Validar formato de fecha
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicial)) {
      alert("El formato de fecha debe ser YYYY-MM-DD");
      return;
    }

    const fechaSimple = (date) => {
      // Validar que la fecha sea válida
      if (!date || isNaN(new Date(date).getTime())) {
        throw new Error('Fecha inválida');
      }
      
      // Simplemente retornar la fecha tal como viene (ya está en formato YYYY-MM-DD)
      console.log('Fecha original:', date);
      console.log('Fecha a enviar:', date);
      return date;
    };

    const url = "/cierre-turno/filtrar";
    let payload = {};

    try {
      payload = {
        codTerminal,
        codPark,
        fechaInicial: fechaSimple(fechaInicial),
      };
    } catch (error) {
      console.error('Error al procesar la fecha:', error);
      alert(`Error al procesar la fecha: ${error.message}`);
      return;
    }

    console.log('URL de búsqueda:', url);
    console.log('Payload a enviar:', payload);

    setBuscando(true);
    try {
      console.log('Enviando petición...');
      const response = await axios.post(url, payload);
      console.log('Respuesta del servidor:', response.data);
      console.log('Tipo de respuesta:', typeof response.data);
      console.log('¿Es array?:', Array.isArray(response.data));
      console.log('Longitud de datos:', response.data?.length);

      setCierreTurnoData(response.data);
      try {
        const resDia = await axios.post("/cierres-dias/buscar", payload);
        setCierreDiaData(Array.isArray(resDia.data) ? resDia.data : []);
      } catch (_) {
        setCierreDiaData([]);
      }
    } catch (error) {
      console.error('=== ERROR EN LA BÚSQUEDA ===');
      console.error('Error completo:', error);
      console.error('Mensaje de error:', error.message);
      console.error('Respuesta del servidor:', error.response?.data);
      console.error('Estado de la respuesta:', error.response?.status);
      alert(`Error al buscar: ${error.response?.data?.message || error.message}`);
    } finally {
      setBuscando(false);
    }
  };

  const handleLimpiar = () => {
    setFiltros({ codTerminal: "", codPark: "", fechaInicial: "" });
    setCierreTurnoData([]);
    setCierreDiaData([]);
    setBuscando(false);
  };

  const handleEditarTurno = (id) => {
    if (window.confirm("¿Deseas editar este registro?")) {
      history.push(`/Planillas/editarturno/${id}`);
    }
  };

  const handleEditarDia = async (id) => {
    if (window.confirm("¿Deseas editar este registro?")) {
      try {
        const response = await axios.get(`/cierres-dias/${id}`);
        if (response.data) {
          history.push(`/Planillas/editarDia/${id}`, { cierreDia: response.data });
        }
      } catch (error) {
        console.error("Error al obtener el registro:", error);
        alert("Error al obtener el registro para editar");
      }
    }
  };

  const handleVolverHome = () => {
    history.push('/Planillas');
  };

  // Suma de reportado solo de los turnos del mismo día (y mismo terminal/parque) que cada cierre de día
  const sumReportadoByCierreDia = useMemo(() => {
    const sumas = {};
    if (!Array.isArray(cierreTurnoData) || !Array.isArray(cierreDiaData)) return sumas;
    const mismoDia = (d1, d2) => {
      if (!d1 || !d2) return false;
      const a = new Date(d1);
      const b = new Date(d2);
      return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    };
    cierreDiaData.forEach((cierre) => {
      const id = cierre.idCierreDia ?? cierre.id;
      let total = 0;
      cierreTurnoData.forEach((turno) => {
        // Excluir turnos con estado 3 (quitar turno) de la suma
        if (Number(turno.estado) === 3) return;
        if (turno.idInicioDia != null && turno.idInicioDia === cierre.idInicioDia &&
            mismoDia(turno.fechaInicial, cierre.fechaInicial) &&
            turno.codTerminal === cierre.codTerminal &&
            turno.codPark === cierre.codPark) {
          total += Number(turno.reportado) || 0;
        }
      });
      sumas[id] = total;
    });
    return sumas;
  }, [cierreTurnoData, cierreDiaData]);

  return (
    <div className="cierre-turno-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 className="cierre-turno-title">Eliminación de turnos</h2>
        <button 
          onClick={handleVolverHome}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
        >
          ← Volver al Home
        </button>
      </div>

      <CierreTurnoFiltroForm
        filtros={filtros}
        onChange={handleFiltroChange}
        onSubmit={buscarCierres}
        onClear={handleLimpiar}
        accionSeleccionada={accionSeleccionada}
        onAccionChange={handleAccionChange}
        getInputConfig={getInputConfig}
        isBuscando={buscando}
      />

      {cierreTurnoData.length > 0 && (
        <div className="table-container">
          <h3>Resultados Cierre de Turno</h3>
          <CierreTurnoTable
            cierres={cierreTurnoData}
            onEditar={handleEditarTurno}
            recargarTabla={async () => {
              await buscarCierres({ preventDefault: () => {} });
            }}
          />
        </div>
      )}

      {cierreDiaData.length > 0 && (
        <div className="table-container" style={{ marginTop: "10px" }}>
          <h3>Resultados Cierre Día</h3>
          <CierreDiaTable
            cierres={cierreDiaData}
            onEditar={handleEditarDia}
            sumReportadoByCierreDia={sumReportadoByCierreDia}
          />
        </div>
      )}
    </div>
  );
};

export default ModificaRecaudoList; 